import { FC, useEffect } from "react";
import { useParams } from "react-router";

import SpinnerContainer from "./spinnerContainer/SpinnerContainer";

export const OAuthRedirect: FC = () => {
  const { redirectUrl } = useParams();

  useEffect(() => {
    if (redirectUrl === undefined) {
      throw new Error("Missing redirect URL!");
    } else {
      const redirUrl = decodeURIComponent(redirectUrl);
      const redirAsUrl = new URL(redirUrl);

      const allowedRedirects = [
        "no.posten.Digipost://oauthredirect",
        "dp://no.digipost.android/oauthredirect",
        "no.posten.Digipost.Test://oauthredirect",
        "no.posten.Digipost.difitest://oauthredirect",
      ];

      let redirectAllowed = false;
      for (const allowedRedir of allowedRedirects) {
        const allowedRedirAsUrl = new URL(allowedRedir);
        if (
          redirAsUrl.protocol === allowedRedirAsUrl.protocol &&
          redirAsUrl.host === allowedRedirAsUrl.host
        ) {
          redirectAllowed = true;
          break;
        }
      }

      if (redirectAllowed) {
        window.location.href = redirUrl;
      }
    }
  }, [redirectUrl]);

  return <SpinnerContainer />;
};
